import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteAPI, getAPI, postAPI, putAPI } from "../../service/http-service";
import { IPromoCode } from "../../portal/PromoCode/IPromoCode";

const PromoCodeAPI = {
  promo_code: "promo_code",
  promo_code_list: "promo_code",
  promo_code_export_excel: "promo_code/export/excel",
  course: "course",
  franchisee_group: "franchisee_group",
  country: "country",
  region: "region",
  state: "state",
  area: "area",
};

export interface PromoCodeResponseData {
  data: IPromoCode[];
}

export interface PromoCodeResponse {
  data: any;
  message: string | undefined;
  errors: [string] | null;
}

export interface PromoCodeState {
  loading: boolean;
  promoCodeResponse: PromoCodeResponse;
  error: string | undefined;
}

const initialState: PromoCodeState = {
  loading: false,
  error: undefined,
  promoCodeResponse: {
    data: undefined,
    message: undefined,
    errors: null,
  },
};

export const promoCodeAction = createAsyncThunk(
  "master/promoCode",
  async (promoCode: any) => {
    try {
      let response;
      switch (promoCode.apiAction) {
        case "list":
          response = await getAPI(PromoCodeAPI.promo_code_list);
          break;
        case "dataById":
          response = await getAPI(`${PromoCodeAPI.promo_code_list}/${promoCode.selectedId}`);
          break;
        case "create":
          response = await postAPI(PromoCodeAPI.promo_code_list, promoCode.formValues);
          break;
        case "update":
          response = await putAPI(PromoCodeAPI.promo_code_list, promoCode.formValues);
          break;
        case "course":
          response = await getAPI(PromoCodeAPI.course);
          break;
        case "franchisee_group":
          response = await getAPI(PromoCodeAPI.franchisee_group);
          break;
        case "country":
          response = await getAPI(PromoCodeAPI.country);
          break;
        case "region":
          response = await getAPI(`${PromoCodeAPI.region}?countryIds=${promoCode?.countryIds}`);
          break;
        case "state":
          response = await getAPI(`${PromoCodeAPI.state}?${promoCode?.api}`);
          break;
        case "area":
          response = await getAPI(`${PromoCodeAPI.area}?${promoCode?.api}`);
          break;
        case "delete":
          response = await deleteAPI(
            `${PromoCodeAPI.promo_code}/${promoCode.id}`
          );
          break;
        case "deleteAll":
          response = await deleteAPI(
            `${PromoCodeAPI.promo_code}?${promoCode.requestParams}`
          );
          break;
        case "exportExcel":
          response = await postAPI(
            PromoCodeAPI.promo_code_export_excel,
            promoCode.formValues
          );
          break;
      }
      return response;
    } catch (err) {
      return err;
    }
  }
);

const promoCodeSlice = createSlice({
  name: "franchisee_group",
  initialState,
  reducers: {
    addObj: (state, action: any) => {
      state.promoCodeResponse.data.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(promoCodeAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(promoCodeAction.fulfilled, (state, { payload }: any) => {
      state.loading = false;
      state.promoCodeResponse = payload;
    });
    builder.addCase(promoCodeAction.rejected, (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.promoCodeResponse.data = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const promoCodeReducer = promoCodeSlice.reducer;
export default promoCodeReducer;
